/* eslint-disable */
/**
 * Qiankun 微前端 CSS 加载问题解决方案
 *
 * ==================== 问题背景 ====================
 * PC 页面通过 qiankun 内嵌到其他系统（主应用和子应用同域名 sf-express.com）
 * 部署环境使用蓝绿发布，用户的 cookie 里有灰度标识
 * 导致 CSS 请求被路由到非默认版本的服务器
 * 非默认版本上没有对应版本的 CSS 文件（文件名带 hash）→ 404 → 页面白屏
 *
 * ==================== 原因分析 ====================
 * qiankun 加载 CSS 分两部分：
 * 1. 入口 CSS（index.html 里的 <link>）→ import-html-entry 用 fetch 加载 → 可配 credentials: 'omit'
 * 2. Webpack 动态 CSS 分块（路由懒加载）→ webpack 运行时创建原生 <link> 标签 → 浏览器加载 → 带 cookie
 * 问题出在第 2 类，webpack 动态创建的 <link> 标签绕过了 qiankun 的 fetch 配置
 *
 * ==================== 解决方案 ====================
 * 重写 HTMLLinkElement.prototype.href 的 setter
 * 当任何代码给 <link> 设置 href="xxx.css" 时，拦截它：
 * 1. 阻止浏览器原生加载（不带 cookie）
 * 2. 用 fetch({credentials: 'omit'}) 加载 CSS 内容（不带 cookie）
 * 3. 转成 Blob URL，设置到 <link> 的 href（Blob URL 是本地资源，浏览器不发网络请求）
 * 4. 保留原始 <link> 元素，webpack 的 onload 回调能正常触发
 *
 * ==================== 安全措施 ====================
 * 1. 域名过滤：只拦截 icas 自己域名的 CSS，不影响主应用和其他子应用
 * 2. 防重机制：__cssHandled 标记防止同一个 <link> 重复 fetch
 * 3. 内存释放：替换前释放旧的 Blob URL，防止内存泄漏
 * 4. 失败回退：fetch 失败时回退到原生加载，保证页面不会卡死
 */

if (window.__POWERED_BY_QIANKUN__) {
  // 设置 webpack 的 publicPath，确保子应用能正确加载资源
  __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__

  // ========== 保存原始 href 的 getter/setter ==========
  // 后续需要用它来操作 <link> 的真实 href，绕过我们的拦截
  var originalHrefDescriptor = Object.getOwnPropertyDescriptor(HTMLLinkElement.prototype, 'href')

  /**
   * 公共方法：用 fetch 无 cookie 加载 CSS，转成 Blob URL 设置到 <link>
   * @param {HTMLLinkElement} linkEl - 要处理的 <link> 元素
   * @param {string} cssUrl - 原始 CSS 文件 URL
   */
  function loadCssAsBlobUrl(linkEl, cssUrl) {
    // 防重：如果这个 <link> 已经在处理中或已处理，直接跳过
    // 场景：webpack 或 import-html-entry 可能对同一个元素多次设置 href
    if (linkEl.__cssHandled) return
    linkEl.__cssHandled = true
    console.log('[icas] Fetching CSS without cookie:', cssUrl)

    // 第一步：清空 href，阻止浏览器发起原生 CSS 请求（带 cookie 的请求）
    originalHrefDescriptor.set.call(linkEl, '')

    // 第二步：用 fetch 加载 CSS，credentials: 'omit' 表示不携带 cookie
    fetch(cssUrl, { credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status)
        return res.blob()
      })
      .then(function (blob) {
        // 第三步：内存释放 —— 如果这个 <link> 之前有旧的 Blob URL，先释放
        // 防止路由来回切换时 Blob URL 不断累积导致内存泄漏
        var oldHref = originalHrefDescriptor.get.call(linkEl)
        if (oldHref && oldHref.startsWith('blob:')) {
          URL.revokeObjectURL(oldHref)
        }

        // 第四步：将 CSS 内容转成 Blob URL
        // Blob URL 格式：blob:https://xxx/uuid
        // 浏览器直接从内存读取，不会发起网络请求，不会带 cookie
        var blobUrl = URL.createObjectURL(blob)
        originalHrefDescriptor.set.call(linkEl, blobUrl)
        console.log('[icas] CSS loaded via blob:', cssUrl)
      })
      .catch(function (err) {
        console.error('[icas] CSS fetch failed, fallback to native:', cssUrl, err)
        // 失败回退：如果 fetch 失败（网络异常、CORS 等），回退到原生加载
        // 保证页面不会因为 CSS 加载失败而卡死
        linkEl.__cssHandled = false // 重置标记，允许重试
        originalHrefDescriptor.set.call(linkEl, cssUrl)
      })
  }

  /**
   * 判断一个 URL 是否是需要拦截的 icas CSS 文件
   * 只拦截 icas 自己域名的 CSS，不影响主应用和其他子应用的 CSS 加载
   * @param {string} url - 要检查的 URL
   * @returns {boolean}
   */
  function isIcasCssUrl(url) {
    console.log('111url是', url)
    if (!url || typeof url !== 'string') return false
    // 必须是 CSS 文件
    if (!/\.css(\?|$)/.test(url)) return false
    // 只拦截 icas 的 CSS（域名包含 icas）
    return url.indexOf('icas') !== -1
  }

  // ========== 重写 HTMLLinkElement.prototype.href 的 setter ==========
  // 拦截所有 <link> 元素的 href 赋值操作
  // 当 webpack 运行时执行 link.href = '/static/css/xxx.css' 时，会触发这个 setter
  Object.defineProperty(HTMLLinkElement.prototype, 'href', {
    get: function () {
      // getter 直接返回原始值，不做任何处理
      return originalHrefDescriptor.get.call(this)
    },
    set: function (value) {
      // 判断条件：
      // 1. this.rel === 'stylesheet' —— 只处理样式表，不处理 icon 等其他 link 类型
      // 2. isIcasCssUrl(value) —— 只处理 icas 域名的 CSS，不影响其他应用
      if (this.getAttribute('rel') === 'stylesheet' && isIcasCssUrl(value)) {
        console.log('[icas] Intercepted CSS link href:', value)
        loadCssAsBlobUrl(this, value)
      } else {
        // 非 icas CSS 或非 stylesheet（如 favicon），正常设置 href
        originalHrefDescriptor.set.call(this, value)
      }
    },
    configurable: true,
    enumerable: true
  })

  console.log('[icas] CSS cookie interception active')
}
